import { render, staticRenderFns } from "./ListadoModulosProgramas.vue?vue&type=template&id=fce038d0"
import script from "./ListadoModulosProgramas.vue?vue&type=script&lang=js"
export * from "./ListadoModulosProgramas.vue?vue&type=script&lang=js"
import style0 from "./ListadoModulosProgramas.vue?vue&type=style&index=0&id=fce038d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports